<template>
  <MUIDialog
    :dismissItem="dismissItem"
    :displayType="displayType"
    :title="title">
    <!-- <section class="settings-groups">
      <MUIListItem
        :class="{ 'is-selected': view === `units` }"
        role="menuitem"
        text="Recipe units"
        @click.native="changeView('units')">
      </MUIListItem>
      <MUIListItem
        :class="{ 'is-selected': view === `notifications` }"
        role="menuitem"
        text="Notifications"
        @click.native="changeView('notifications')">
      </MUIListItem>
    </section> -->
    <div class="settings-list">
      <!-- <div class="preferences-account" style="display: block;" v-if="view=='account'">
        {{$store.state.User.email}}
      </div> -->
      <div style="display: block;" v-if="view=='units'">
        <div class="preference-group">
          <div class="preference-item">
            <label>
              <div class="preference-title">Use Smart Quantities</div>
            </label>
            <div class="preference-description">Units and measures will display in abbreviated form. Required to scale&nbsp;recipes.</div>
            <div class="preference-control">
              <MUIToggle v-model="preferences.smartQuantities"></MUIToggle>
            </div>
          </div>
          <div class="preference-item item-system">
            <label>
              <div class="preference-title">System of measurement</div>
            </label>
            <div class="preference-description">Your preferred system of measurement.</div>
            <div class="preference-control control-dropdown">
              <MUIMenu :items="systemOptions" anchor="right" :showCaret="true">
                <span slot="button">{{options.system[preferences.system]}}</span>
              </MUIMenu>
            </div>
          </div>
          <div class="preference-item">
            <label>
              <div class="preference-title">Keep screen on <div class="label" v-if="!$store.state.device.hasNativeWakeLock">Unsupported</div></div>
            </label>
            <div class="preference-description">In supported browsers your screen will remain on while viewing a recipe. Requires Chrome, Edge or Opera browsers.</div>
            <div class="preference-control">
              <MUIToggle v-model="preferences.keepScreenOn"></MUIToggle>
            </div>
          </div>
        </div>
      </div>
      <div style="display: block;" v-if="view=='notifications'">
        <!-- <h1>Notifications</h1>
        <p>Choose what types of emails Cookmark should be sending to you.</p> -->
        <div class="preference-group">
          <div class="preference-item">
            <label>
              <div class="preference-title">Important updates</div>
            </label>
            <div class="preference-description">Receive emails when we have important Cookmark updates to share.</div>
            <div class="preference-control">
              <MUIToggle v-model="preferences.notificationUpdates"></MUIToggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </MUIDialog>
</template>

<script>
import {
  MUIDialog,
  MUIListItem,
  MUIMenu,
  MUIToggle
} from '../components'

import { APP } from '../config'

export default {
  components: {
    MUIDialog,
    MUIListItem,
    MUIMenu,
    MUIToggle
  },
  data () {
    return {
      dismissItem: {
        name: 'Done'
      },
      displayType: APP,
      options: {
        system: {
          default: 'Don\'t convert',
          customary: 'Customary',
          metric: 'Metric'
        }
      },
      preferences: {
        keepScreenOn: this.$store.state.User.preferences.keepScreenOn,
        smartQuantities: this.$store.state.User.preferences.smartQuantities,
        system: this.$store.state.User.preferences.system,
        notificationUpdates: this.$store.state.User.preferences.notificationUpdates
      },
      title: 'Preferences',
      view: 'units'
    }
  },
  computed: {
    systemOptions () {
      return Object.entries(this.options.system).map(([preference, name]) => {
        return {
          id: `system-${preference}`,
          class: { active: this.preferences.system === preference },
          fn: () => { this.changePreference('system', preference) },
          name: name
        }
      })
    }
  },
  methods: {
    changeView (view) {
      this.view = view
    },
    changePreference (attr, value) {
      this.preferences[attr] = value
    }
  },
  watch: {
    'preferences.keepScreenOn' (newVal, oldVal) {
      this.$store.dispatch('setPreference', {
        userId: this.$store.state.User.uid,
        preference: {
          keepScreenOn: newVal
        }
      }).then(() => {
        this.$track(`Preference Updated`, {
          name: 'preferences.keepScreenOn',
          from: oldVal,
          to: newVal
        })
      })
    },
    'preferences.notificationUpdates' (newVal, oldVal) {
      this.$store.dispatch('setPreference', {
        userId: this.$store.state.User.uid,
        preference: {
          notificationUpdates: newVal
        }
      }).then(() => {
        this.$track(`Preference Updated`, {
          name: 'preferences.notificationUpdates',
          from: oldVal,
          to: newVal
        })
      })
    },
    'preferences.smartQuantities' (newVal, oldVal) {
      this.$store.dispatch('setPreference', {
        userId: this.$store.state.User.uid,
        preference: {
          smartQuantities: newVal
        }
      }).then(() => {
        this.$track(`Preference Updated`, {
          name: 'preferences.smartQuantities',
          from: oldVal,
          to: newVal
        })
      })
    },
    'preferences.system' (newVal, oldVal) {
      this.$store.dispatch('setPreference', {
        userId: this.$store.state.User.uid,
        preference: {
          system: newVal
        }
      }).then(() => {
        this.$track(`Preference Updated`, {
          name: 'preference.system',
          from: oldVal,
          to: newVal
        })
      })
    }
  }
}
</script>
<style lang="sass">
.settings-groups
  border-right: 1px solid #e1e0e0
  .mui-list-item
    cursor: pointer
    padding-left: 24px
    margin-left: -24px
    width: 148px
    &.is-selected
      background: #f2f8ff
    .mui-list-item__graphic
      margin-right: 0
.settings-list
  width: 100%
  .preference-item
    position: relative
    margin-bottom: 16px
    .preference-control
      position: absolute
      right: 0
      top: 8px
      &.control-dropdown
        top: 0
    .preference-title
      font-size: 1em
      font-weight: 500
      user-select: none
    .preference-description
      font-size: 0.9em
      line-height: 24px
      color: #545657
.label
  display: inline-block
  margin: 0 4px
  padding: 0px 8px
  font-size: 11px
  font-weight: 600
  text-transform: uppercase
  color: rgb(71, 85, 105)
  background-color: rgb(226, 232, 240)
  border-radius: 4px
</style>



// WEBPACK FOOTER //
// src/views/PreferencesDialog.vue